var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMixed = function SvgMixed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5c.275 0 .5.225.5.5v3c0 .275-.225.5-.5.5H5a.5.5 0 0 1-.5-.5V7c0-.275.225-.5.5-.5zM5 5c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm14 1.5c.275 0 .5.225.5.5v7c0 .275-.225.5-.5.5h-2a.5.5 0 0 1-.5-.5V7c0-.275.225-.5.5-.5zM17 5c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM7 15h4.5c.275 0 .5.225.5.5V17c0 .275-.225.5-.5.5H7a.5.5 0 0 1-.5-.5v-1.5c0-.275.225-.5.5-.5m-2 .5V17c0 1.103.897 2 2 2h4.5c1.103 0 2-.897 2-2v-1.5c0-1.103-.897-2-2-2H7c-1.103 0-2 .897-2 2"
  })));
};
export default SvgMixed;